import { fetchFilterData } from '#action/project/list-filter';
import { UserFilterOptionService, DevicesFilterOptionService } from '#service/autocomplete-service/service';
import { FilterOption } from '#service/autocomplete-service/option';
import { uuidv4 } from '#helper';

/**
interface IFilterComponent {
  type: string;
  name: string;
  label: string;
  relatedTo: string;
  id: number;
  options?: { [key: number]: string };
  fetchOptionsService?: Function;
  searchFields?: string[];
  formatValue?: Function;
  validation?: Function;
}
*/

const projectExpiredOptions = [
  { label: 'All projects', value: '0', id: '0', default: true },
  { label: 'Active only', value: '1', id: '1' }
];

const subprojectsOptions = [
  { label: 'On', value: '1', id: '1' },
  { label: 'Off', value: '0', id: '0', default: true }
];

const searchProps = {
  type: 'ProjectFilterSearch',
  name: 'search',
  label: 'Search a project',
  relatedTo: 'project',
  id: uuidv4()
};

const filterDeviceComponent = {
  type: 'MultipleSelect',
  name: 'device',
  label: 'Device',
  relatedTo: 'project',
  id: uuidv4(),
  fetchOptionsService: DevicesFilterOptionService,
  searchFields: ['title']
};

const filterUserComponent = {
  type: 'MultipleSelect',
  name: 'user',
  label: 'User',
  relatedTo: 'project',
  id: uuidv4(),
  fetchOptionsService: UserFilterOptionService,
  searchFields: ['fullName']
};

const projectExpiredComponent = {
  type: 'RadioButtonsGroup',
  name: 'unexpired',
  label: 'Status',
  relatedTo: 'project',
  id: uuidv4(),
  options: projectExpiredOptions.map(o => new FilterOption(o, o.label))
};

const subProjectsComponent = {
  type: 'SubprojectRadioButtonsGroup',
  name: 'subproject',
  label: 'Subprojects',
  mobileLabel: 'Subprojects',
  relatedTo: 'project',
  id: uuidv4(),
  options: subprojectsOptions.map(o => new FilterOption(o, o.label))
};

const filterConfig = {
  customActions: {
    fetchFilterData
  },
  searchProps,
  components: [
    filterDeviceComponent,
    filterUserComponent,
    projectExpiredComponent,
    subProjectsComponent
  ]
};

export default filterConfig;
